angular.module('LeasePilot').directive('deleteFormModal', [
  '$http',
  '$mdDialog',
  function($http, $mdDialog) {
    return {
      restrict: 'E',
      templateUrl: 'delete_form_modal.html',
      link: function($scope, element, attrs) {
        $scope.form = {
          name: attrs.name,
          deal_type: attrs.dealType,
          flavor: attrs.flavor,
          company_id: attrs.companyId,
        };

        $scope.confirmText = '';
        $scope.isConfirmed = false;
        $scope.isProcessing = false;

        $scope.textChanged = function() {
          $scope.isConfirmed = $scope.confirmText === 'DELETE FORM';
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.delete = function() {
          if (!$scope.isConfirmed) return;

          $scope.isProcessing = true;
          var data = $.param({ form: $scope.form });

          $http.delete('/api/forms?' + data)
            .then(function() {
              window.location.reload();
            })
            .catch(function(error) {
              console.error('Error deleting form:', error);
              $scope.isProcessing = false;
            });
        };
      },
    };
  },
]);
